import { render } from "./ProjectUserPledgeMeta.vue?vue&type=template&id=2d2682a2"
import script from "./ProjectUserPledgeMeta.vue?vue&type=script&lang=js"
export * from "./ProjectUserPledgeMeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__